import { Env } from '@repo/types/config';
import { WidgetStudy } from '@repo/types/models';
import api from './api';

const generateURL = (studyId: string, demoMode: boolean) => {
    const baseUrl = `/v2/study/id/${studyId}`;

    const params = new URLSearchParams();

    if (demoMode) {
        params.append('mode', 'demo');
    }

    const queryString = params.toString();
    const url = queryString ? `${baseUrl}?${queryString}` : baseUrl;

    return url;
};

export async function getStudy(studyId: string, demoMode: boolean, env: Env): Promise<WidgetStudy> {
    return (await api.get(generateURL(studyId, demoMode), env)) as WidgetStudy;
}
